import { ITALogo } from "assets";
import { IKnowledgeSection } from "./types";

const directTax: IKnowledgeSection = {
  key: "direct-tax",
  title: "Direct Tax",
  // icon: ITALogo,
  color: "#2563eb",
  // TODO: these are placeholders copied from Income Tax — swap in the real
  // Direct Tax links. Two sections must not share a href, or their cards clash
  // in the "All" view.
  links: [
    {
      title: "Aaykar Seva Kendra Locator",
      href: "https://www.incometaxindia.gov.in/aaykar-seva-kendra",
    },
    {
      title: "CBDT Orders",
      href: "https://www.incometaxindia.gov.in/miscellaneous-communications?categoryId=13335677",
    },
    {
      title: "Department Recruitment Notices",
      href: "https://www.incometaxindia.gov.in/recruitment-notices",
    },
    {
      title: "Department Recruitment Rules",
      href: "https://www.incometaxindia.gov.in/recruitment-rules",
    },
    {
      title: "Departmental Examination",
      href: "https://www.incometaxindia.gov.in/miscellaneous-communications?categoryId=13335674",
    },
    {
      title: "FAQs and Guidance Notes on Forms as per Income-tax Rules, 2026",
      href: "https://www.incometaxindia.gov.in/w/faqs-on-forms-as-per-income-tax-rules-2026-1",
    },
    {
      title: "Income & Tax Calculator",
      href: "https://eportal.incometax.gov.in/iec/foservices/#/TaxCalc/calculator",
    },
    {
      title: "Income Tax Act, 1961",
      href: "https://www.incometaxindia.gov.in/income-tax-act?doAsUserId=P8dqHo7GMNv%252FXYXPfeJIUA%253D%253D%253FcategoryId%253D10191473%253FcategoryId%253D39787%253FcategoryId%253D40193%3FcategoryId%3D10191473%3FcategoryId%3D10191473%3FcategoryId%3D40193%3FcategoryId%3D39787%3FcategoryId%3D40193%3FcategoryId%3D40193",
    },
    {
      title: "Income Tax Act, 2025",
      href: "https://www.incometaxindia.gov.in/income-tax-act-2025?doAsUserId=P8dqHo7GMNv%252FXYXPfeJIUA%253D%253D%253FcategoryId%253D10191473%253FcategoryId%253D39787%253FcategoryId%253D40193%3FcategoryId%3D10191473%3FcategoryId%3D10191473%3FcategoryId%3D40193%3FcategoryId%3D39787%3FcategoryId%3D40193%3FcategoryId%3D40193",
    },
    {
      title: "Income Tax Circulars",
      href: "https://www.incometaxindia.gov.in/circulars",
    },
    {
      title: "Income Tax Department Media Gallery",
      href: "https://www.incometaxindia.gov.in/advertisement-gallery",
    },
    {
      title: "Income Tax Due Dates Calendar",
      href: "https://www.incometaxindia.gov.in/tax-calendar",
    },
    {
      title: "Income Tax Forms (Income Tax Rules, 1962)",
      href: "https://www.incometaxindia.gov.in/income-tax-forms",
    },
    {
      title: "Income Tax Forms (Income Tax Rules, 2026)",
      href: "https://www.incometaxindia.gov.in/income-tax-forms-2026",
    },
    {
      title: "Income Tax Notifications",
      href: "https://www.incometaxindia.gov.in/notifications",
    },
    {
      title: "Income Tax Office Locator",
      href: "https://www.incometaxindia.gov.in/income-tax-office",
    },
    {
      title: "Income Tax Press Releases",
      href: "https://www.incometaxindia.gov.in/press-release",
    },
    {
      title: "Income Tax Rules, 1962",
      href: "https://www.incometaxindia.gov.in/income-tax-rules?doAsUserId=P8dqHo7GMNv%252FXYXPfeJIUA%253D%253D%253FcategoryId%253D10191473%253FcategoryId%253D39787%253FcategoryId%253D40193%3FcategoryId%3D10191473%3FcategoryId%3D10191473%3FcategoryId%3D40193%3FcategoryId%3D39787%3FcategoryId%3D40193%3FcategoryId%3D40193",
    },
    {
      title: "Income Tax Rules, 2026",
      href: "https://www.incometaxindia.gov.in/income-tax-rule-2026?doAsUserId=P8dqHo7GMNv%252FXYXPfeJIUA%253D%253D%253FcategoryId%253D10191473%253FcategoryId%253D39787%253FcategoryId%253D40193%3FcategoryId%3D10191473%3FcategoryId%3D10191473%3FcategoryId%3D40193%3FcategoryId%3D39787%3FcategoryId%3D40193%3FcategoryId%3D40193",
    },
    {
      title: "ITAT Case Status",
      href: "https://itat.gov.in/judicial/casestatus",
    },
    {
      title: "ITAT Notice Board",
      href: "https://itat.gov.in/judicial/notice_board",
    },
    {
      title: "ITAT Orders",
      href: "https://itat.gov.in/judicial/tribunalorders",
    },
    {
      title: "ITAT Special Bench Orders",
      href: "https://itat.gov.in/judicial/sborders",
    },
    {
      title: "Jurisdictional TPS Office Locator",
      href: "https://www.incometaxindia.gov.in/jurisdictional-tps-office",
    },
    {
      title: "Legal Maxim",
      href: "https://www.incometaxindia.gov.in/legal-maxim",
    },
    {
      title: "TDS, TDS, Income Tax Slabs & DTAA Rate Chart",
      href: "https://traces.tdscpc.gov.in/thingsToKnow/ratecharts",
    },
    {
      title: "Utility to Compare Forms of Income Tax Rules, 1962 v/s 2026",
      href: "https://www.incometaxindia.gov.in/utility-to-check-forms-under-income-tax-rule-1962-vis-a-vis-income-tax-rules-2026",
    },
    {
      title: "Utility to Compare Provisions of Income Tax Act, 1961 v/s  2025",
      href: "https://www.incometaxindia.gov.in/utility-to-check-provisions-of-income-tax-act-1961-vis-a-vis-income-tax-act-2025",
    },
    {
      title: "Utility to Compare Rules of Income Tax Rules, 1962 v/s 2026",
      href: "https://www.incometaxindia.gov.in/utility-to-check-provisions-of-income-tax-rules-1962-vis-a-vis-income-tax-rules-2026",
    },
  ],
};

export default directTax;
